import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../../environments/environment';
import { RedirectService } from '../../services/redirect/redirect.service';
import { CaasService } from '../../services/caas/caas.service';
import { ConfirmationsPageContent } from '../../models/aem-graphql.model';
import { dropdownObject } from '../../models/caas.model';
import { DropdownMenuData } from '@vg-constellation/angular-19/dropdown';
import { BannerSize, BannerVariant } from '@vg-constellation/angular-19/banner';

@Component({
  selector: 'app-login-error',
  templateUrl: './login-error.component.html',
  styleUrls: ['./login-error.component.scss'],
  standalone: false
})
export class LoginErrorComponent implements OnInit {

  protected readonly environment = environment;
  downloadLinkLabel = environment.downloadAccountLink.label;
  downloadLinkUrl = environment.downloadAccountLink.url;
  tetriaryNavigationOptions: Array<dropdownObject> = [];
  confirmsContent: ConfirmationsPageContent | null = null;
  shouldShowErrorBanner: boolean = false;
  dropdownMenuOptions: DropdownMenuData = { groups: [{ items: [] }] };
  viewDropdownContent: any[] = [];

  errorBannerConfig: { size: BannerSize; heading: string; body: string; closable: boolean; collapsible: boolean; type: BannerVariant; variant: BannerVariant } = {
    size: 'medium',
    heading: '',
    body: '',
    closable: false,
    collapsible: false,
    type: 'error',
    variant: 'warning'
  };

  readonly content = {
    accessDeniedError: {
      heading: 'Access denied',
      body: "You don't currently have the required permissions.",
      sailpointRequest: 'Please submit <strong>PI INTERNAL SITE ACCESS</strong> role in SailPoint to gain access.',
    },
    sailpointAccessError: environment.production
      ? 'Choose <strong>OKTA</strong> for Production access.'
      : 'Choose <strong>OKTA-preview</strong> for test region access.',
    poidNotPresentError: {
      heading: 'Something went wrong',
      body: 'POID is not present in the cookie. Please do a <b>client search again</b>.',
    },
  };

  reason!: string;

  constructor(
    private redirectService: RedirectService,
    private readonly caasService: CaasService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.reason = this.route.snapshot.queryParamMap.get('reason') || 'default';
    // Scroll to top for accessibility
    window.scrollTo({ top: 0, behavior: 'smooth' });

    // If this is an external environment and user hits login-error,
    // redirect them to INTERNAL_URL
    if (!environment.internal && environment.CONFIRMATIONS?.INTERNAL_URL) {
      this.redirectService.redirectTo(environment.CONFIRMATIONS.INTERNAL_URL);
    }

    // Get CaaS data for navigation and content
    this.getCaasData();
  }

  getCaasData() {
    const pageContent = this.caasService.getPageContent();
    if (pageContent) {
      this.confirmsContent = pageContent;
    }

    // Set up navigation options
    this.tetriaryNavigationOptions = Object.keys(this.confirmsContent?.tabOptions || {}).sort().map(key =>
      ({
        'optionLabel': this.confirmsContent!.tabOptions[key].optionLabel,
        'optionUrl': this.confirmsContent!.tabOptions[key].optionUrl,
      }),
    );

    // Set up dropdown options
    this.viewDropdownContent = Object.keys(this.confirmsContent?.dropdownOptions || {}).sort().map(key =>
      ({
        'labelText': this.confirmsContent!.dropdownOptions[key].optionLabel,
        'id': this.confirmsContent!.dropdownOptions[key].optionUrl ? this.confirmsContent!.dropdownOptions[key].optionUrl : '0',
      }),
    );

    this.dropdownMenuOptions = {groups: [{items: this.viewDropdownContent}]};
  }

  viewRedirect(event: any) {
    if (event.activeItems[0] !== '0') {
      window.open(event.activeItems[0], '_self');
    }
  }
}
